import { render, staticRenderFns } from "./ToothTreatmentEditor.vue?vue&type=template&id=71cfc8e6&scoped=true&"
import script from "./ToothTreatmentEditor.vue?vue&type=script&lang=js&"
export * from "./ToothTreatmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ToothTreatmentEditor.vue?vue&type=style&index=0&id=71cfc8e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfc8e6",
  null
  
)

export default component.exports